import { ContactPage, History, AssignmentTurnedIn } from "@mui/icons-material";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import React from "react";

import TabPanel from "./TabPanel";

interface MobileTabsProps {
  tabValue: number;
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  leadInfoForm: React.ReactNode;
  activityHistory: React.ReactNode;
}

const MobileTabs: React.FC<MobileTabsProps> = ({
  tabValue,
  handleTabChange,
  leadInfoForm,
  activityHistory,
}) => {
  return (
    <Box sx={{ flex: 1, overflowY: "auto" }}>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        variant="fullWidth"
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab icon={<ContactPage />} label="Info" id="lead-tab-0" />
        <Tab icon={<History />} label="Activity" id="lead-tab-1" />
        <Tab icon={<AssignmentTurnedIn />} label="Tasks" id="lead-tab-2" />
      </Tabs>

      <Box sx={{ p: 2 }}>
        <TabPanel value={tabValue} index={0}>
          {leadInfoForm}
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          {activityHistory}
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <Typography variant="body1" color="text.secondary" textAlign="center">
            No tasks assigned yet.
          </Typography>
        </TabPanel>
      </Box>
    </Box>
  );
};

export default MobileTabs;
